import React, { useEffect } from 'react'
import { Modal, Row, Col, App, Button, Space } from 'antd'
import { useState } from 'react'
import classes from './income.module.css'
import { useDingdanshouruUpdateQuery, useSKchaosongMutation, useDingdanshouruZTXGMutation } from '../../store/DianShangYeWuApi'
import Asterisk from '../../cpn/Asterisk'
import DocumentRule from '../../cpn/DocumentRule'       
import ClientCheck from '../../system/client/ClientCheck'
import ReportCheck from '../report/ReportCheck'
import Copy from '../../cpn/Copy'
import StateTag from '../../cpn/StateTag';
import IncomeNodeCheck from './IncomeNodeCheck'
import Icon from '../../cpn/Icon'
import FilePreview from '../../cpn/FilePreview'
import { usePrintModal } from '../../cpn/usePrintModal'
import IncomeFinanceWithdraw from './IncomeFinanceWithdraw'
import IncomeFinanceAmount from './IncomeFinanceAmount'
import IncomeFinanceZFLX from './IncomeFinanceZFLX'
import AccountCheck from 'system/account/AccountCheck';
function IncomeCheck(props) {
    const {message} = App.useApp()
    const yh_qx = props.yh_qx || '';
    const [open, setOpen] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(open, '收款单')
    const [info, setInfo] = useState({
        ddsr_content: '',
        ddsr_ctime: '',
        ddsr_price: '',
        ddsr_uname: '',
        ddsr_num: '',
        ddsr_type_name: '',
        ddsr_kh_name: '',
        ddsr_kh_id: '',
        ddsr_type_id: '',
        ddsr_amount: '',
        ddsr_date: '',
        ddsr_date_end: '',
        ddsr_bzd_name: '',
        ddsr_bzd_danhao: '',
        ddsr_id: '',
        ddsr_yuedu: '',
        ddsr_uid: '',
        ddsr_state: '',
        ddsr_state_time: '',
        ddsr_cw_content: '',
        ddsr_zflx: '',
    })
    // 格式化金额显示
    const formatCurrency = (amount) => {
        return `￥${Number(amount).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };
    const { data, isSuccess } = useDingdanshouruUpdateQuery({ ddsr_id: props.ddsr_id }, { skip: !open, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            setInfo(prev=>({...prev,
                ddsr_content: data.Result.ddsr_content,
                ddsr_ctime: data.Result.ddsr_ctime,
                ddsr_price: data.Result.ddsr_price,
                ddsr_uname: data.Result.ddsr_uname,
                ddsr_num: data.Result.ddsr_num,
                ddsr_type_name: data.Result.ddsr_type_name,
                ddsr_kh_name: data.Result.ddsr_kh_name,
                ddsr_kh_id: data.Result.ddsr_kh_id,
                ddsr_type_id: data.Result.ddsr_type_id,
                ddsr_amount: data.Result.ddsr_amount,
                ddsr_date: data.Result.ddsr_date,
                ddsr_date_end: data.Result.ddsr_date_end,
                ddsr_bzd_name: data.Result.ddsr_bzd_name,
                ddsr_bzd_danhao: data.Result.ddsr_bzd_danhao,
                ddsr_id: data.Result.ddsr_id,
                ddsr_yuedu: data.Result.ddsr_yuedu,
                ddsr_uid: data.Result.ddsr_uid,
                ddsr_state: data.Result.ddsr_state,
                ddsr_state_time: data.Result.ddsr_state_time,
                ddsr_name: data.Result.ddsr_name,
                ddsr_bm_name: data.Result.ddsr_bm_name,
                ddsr_qyyhzh_name: data.Result.ddsr_qyyhzh_name,
                ddsr_qyyhzh_id: data.Result.ddsr_qyyhzh_id,
                ddsr_image_name: data.Result.ddsr_image_name,
                ddsr_image_file: data.Result.ddsr_image_file,
                ddsr_cw_content: data.Result.ddsr_cw_content,
                ddsr_zflx: data.Result.ddsr_zflx,
                ddsr_qyyhzh_date: data.Result.ddsr_qyyhzh_date,
            }))
        }
    }, [data, isSuccess])
    //抄送
    const [ddsrChaosong] = useSKchaosongMutation()
    //取消提交
    const [ztxg] = useDingdanshouruZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a 
                type='check' 
                onClick={() => { 
                    if(props.ddsr_sp_state==='2' && props.ddsr_sp_jd_name==='抄送'){
                        ddsrChaosong({
                            'ddsr_sp_id': props.ddsr_sp_id,     //抄送节点id
                            'ddsr_id': props.ddsr_id,
                            'ddsr_sp_yh_id': props.ddsr_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpen(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.ddsr_state === '5' && props.ddsr_uid === props.yh_id){
                        ztxg({
                            ddsr_id:props.ddsr_id,
                            ddsr_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')
                                setOpen(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpen(true);  
                    }
                }} 
            >
                {(props.ddsr_sp_state==='2' && props.ddsr_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.ddsr_state==='5' && props.ddsr_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.ddsr_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.ddsr_sp_ddsr_kh_name?props.ddsr_sp_ddsr_kh_name:props.ddsr_kh_name}
            </a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpen(false)}>
                        关闭
                    </Button>
                ]}
            >
                <div ref={modalRef}>
                 <Row style={{width:"1280px"}}>
                    {(info.ddsr_state === '5' || info.ddsr_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/incomeFinished.png'} alt="收款单" width={150} height={150}/>
                    </div>} 
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF0033',borderLeft:'3px solid #FF0033'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#FF0033',borderTop:'3px solid #FF0033'}}>收款单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF0033',borderRight:'3px solid #FF0033'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF0033',color:'#FF0033'}}><Asterisk color='red'/> 收款事由</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {info.ddsr_name}
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <ClientCheck kh_name={info.ddsr_kh_name} kh_id={info.ddsr_kh_id} qy_name={info.qy_name} trimLength={15} />
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF0033'}}>
                            {info.ddsr_bm_name}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            {info.ddsr_date}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            {formatCurrency(info.ddsr_amount)}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>往来类型</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #FF0033'}}>
                            {info.ddsr_zflx}
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033',padding:'7px'}}>备注</Col>
                        <Col span={6}  className={classes.col_middle_input} >
                            <Copy title={info.ddsr_content} />
                        </Col>                                   
                        <Col span={2} className={classes.col_middle_label} >团队名称</Col>
                        <Col span={6}  className={classes.col_middle_input} >
                            <ReportCheck dsbzd_id={info.ddsr_bzd_id} dsbzd_name={info.ddsr_bzd_name} />
                        </Col> 
                        <Col span={2}  className={classes.col_middle_label}> 转账记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF0033'}}>
                            {info.ddsr_qyyhzh_date}转入<AccountCheck qyyhzh_id={info.ddsr_qyyhzh_id} name={info.ddsr_qyyhzh_name} trimLength={15} />
                        </Col>                                   
                        {/* 第四行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033',padding:'7px'}}>附件</Col>
                        <Col span={14}  className={classes.col_middle_input} >
                            <FilePreview 
                                fileNames={info.ddsr_image_file} 
                                fileUrls={info.ddsr_image_name} 
                            />
                        </Col>                                                           
                        <Col span={2} className={classes.col_middle_label}>编号/状态</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #FF0033'}}>
                            {info.ddsr_id} &emsp;<StateTag state={info.ddsr_state} />
                        </Col>   
                         {/* 第五行 */}
                         <Col span={24} className={classes.bottom_row}>
                            <IncomeNodeCheck 
                                ddsr_id={props.ddsr_id} 
                                qy_id={props.qy_id} 
                                user_id={props.yh_id} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name} 
                                qy_name={props.qy_name}
                                ddsr_uname={info.ddsr_uname}
                                ddsr_ctime={info.ddsr_ctime}
                                ddsr_state_time={info.ddsr_state_time}
                            />
                        </Col>                                                      
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            {info.ddsr_cw_content?<span style={{color:'#FF0000'}}>{info.ddsr_cw_content}</span>:null}
                            {(props.yh_id === props.ddsr_uid && props.ddsr_state ==='4') ? <Icon type='withdraw' onClick={() => {
                                                                                                // 如果正在提交中，直接返回
                                                                                                if (isSubmitting) {
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                // 设置提交状态
                                                                                                setIsSubmitting(true);                                                                                                
                                                                                                ztxg({
                                                                                                    ddsr_id:props.ddsr_id,
                                                                                                    ddsr_state: '1',
                                                                                                }).then((res) => {
                                                                                                    if(res.data.Status === 'success') {
                                                                                                        message.success('收款单取消提交成功！')
                                                                                                        setOpen(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }else{
                                                                                                        message.error('收款单取消提交失败！'+res.data.Message)
                                                                                                        setOpen(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }
                                                                                                    // 3秒后恢复可点击状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                }).catch((err) => {
                                                                                                    // 出错时也要恢复状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                })
                                                                                            }} /> : null}
                            {yh_qx.includes('管理') ? <Space size={20}>
                                <IncomeFinanceWithdraw ddsr_id={props.ddsr_id} ddsr_cw_content={info.ddsr_cw_content} ddsr_amount={info.ddsr_amount}/>
                                <IncomeFinanceAmount ddsr_id={props.ddsr_id} ddsr_state={info.ddsr_state} ddsr_cw_content={info.ddsr_cw_content} ddsr_amount={info.ddsr_amount} />
                                <IncomeFinanceZFLX ddsr_id={props.ddsr_id} ddsr_zflx={info.ddsr_zflx} />
                            </Space> : null}
                        </Col>
                    </Row>
                </div>
            </Modal>
        </>
    )
}

export default IncomeCheck